import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type ColorOptionClasses =
  | 'container'
  | 'color'
  | 'activeColor'
  | 'activeColorBorder'
  | 'smallColor'
  | 'smallBorder'
  | 'banIcon'
  | 'disabled';

const colorOptionStyles = makeStyles<ISpcTheme, ColorOptionClasses>(
  ({ palette, spacing, transitions }) => ({
    container: {
      position: 'relative',
    },
    color: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 26,
      height: 26,
      borderRadius: '50%',
      cursor: 'pointer',
      transition: transitions.create(['transform']),
      zIndex: -10,

      '&:hover': {
        transform: 'scale(1.15)',
      },
    },
    activeColor: {
      transform: 'scale(1.15)',
      boxShadow: 'none',
    },
    activeColorBorder: {
      position: 'absolute',
      background: 'transparent',
      width: 32,
      height: 32,
      border: `${spacing(0.1)} solid ${palette.primary.main}`,
      borderRadius: '50%',
      cursor: 'default',
      zIndex: 0,
    },
    smallColor: {
      width: 20,
      height: 20,
    },
    smallBorder: {
      position: 'absolute',
      background: 'transparent',
      border: `${spacing(0.1)} solid ${palette.primary.main}`,
      borderRadius: '50%',
      cursor: 'default',
      zIndex: 0,
      width: 26,
      height: 26,
    },
    disabled: {
      opacity: 0.8,
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
    banIcon: {
      stroke: palette.error.main,
      position: 'absolute',
      zIndex: 0,
      top: -10,
      left: -10,
      width: 46,
      transform: 'rotate(90deg)',
    },
  }),
  { name: 'Customise_ColorOption' },
);

export default colorOptionStyles;
